import React, { useState } from 'react'
import Navbar from '../Comman_Layout/Header/Navbar'
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';
import Footer from '../Comman_Layout/Footer/Footer';
import { useFormik } from 'formik'
import * as Yup from "yup";
import axios from 'axios';
import Swal from 'sweetalert2';
import $ from "jquery";
import { useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Step, Stepper } from 'react-form-stepper';

const ITServiceProviderCompanyBank = () => {
    const navigate = useNavigate();
    // console.log(JSON.parse(localStorage.getItem("company_details")).name_of_organisation);

    const [initialValues, setInitialValues] = useState({
        name_of_organisation: localStorage.getItem("company_details") ? JSON.parse(localStorage.getItem("company_details")).name_of_organisation : "",
        bank_account_no: "",
        bank_name: "",
        bank_branch: "",
        bank_ifsc: "",
    });
    useEffect(() => {
        // console.log("ccc:::", JSON.parse(localStorage.getItem("company_details")).name_of_organisation);

        if (localStorage.getItem('company_bank_details')) {
            // console.log("In usestate.")
            let companyBankData = JSON.parse(localStorage.getItem("company_bank_details"));
            console.log("companyBankData from localStorage::", companyBankData);
            setInitialValues({
                name_of_organisation: localStorage.getItem("company_details") ? JSON.parse(localStorage.getItem("company_details")).name_of_organisation : "",
                bank_account_no: companyBankData.bank_account_no,
                bank_name: companyBankData.bank_name,
                bank_branch: companyBankData.bank_branch,
                bank_ifsc: companyBankData.bank_ifsc,
            })
        }

    }, []);
    const formik = useFormik({
        initialValues: initialValues,
        enableReinitialize: true,
        validationSchema: Yup.object({
            name_of_organisation: Yup.string()
                .required("Please Enter Name of Organization in first Step."),
            bank_account_no: Yup.string()
                .required("Bank Account No. is required.")
                .matches(/^[0-9]+$/, "Must contain digits only."),
            bank_name: Yup.string()
                .required("Bank Name is required."),
            bank_branch: Yup.string()
                .required("Bank Branch is required."),
            bank_ifsc: Yup.string()
                .required("Bank IFSC is required.")
        }),

        onSubmit: (values, { resetForm }) => {
            let timerInterval;
            console.log(values, "vals");
            Swal.fire({
                title: 'Please Wait...',
                html: 'Your query is being submitted.',
                timer: 30000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading()
                    // const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                        //   b.textContent = Swal.getTimerLeft()
                    }, 100)
                },
                willClose: () => {
                    clearInterval(timerInterval)
                }

            })
            const config = {
                headers: {
                    'content-type': 'multipart/form-data'
                }
            }
            // const formData = new FormData();
            // formData.append("contact_person1_name", values.contact_person1_name)
            // formData.append("contact_person1_designation", values.contact_person1_designation)
            // formData.append("contact_person1_mobile", values.contact_person1_mobile)
            // formData.append("contact_person1_email", values.contact_person1_email);
            // formData.append("contact_person2_name", values.contact_person2_name)
            // formData.append("contact_person2_designation", values.contact_person2_designation)
            // formData.append("contact_person2_mobile", values.contact_person2_mobile)
            // formData.append("contact_person2_email", values.contact_person2_email);

            if (!localStorage.getItem("company_details")) {
                Swal.fire({
                    icon: 'warning',
                    showCancelButton: true,
                    // showConfirmButton: true,
                    showLoading: false,
                    // confirmButtonText: 'Save',
                    cancelButtonText:"Okay",
                    title: 'Warning!',
                    text: 'Please fill Company Details first.',
                })
                navigate("/it-service-provider-company-details");
            } else {
                // axios.post('https://alobhaapi.alobhatech.com/post-associate-partner', formData, config) //for files
                let id = JSON.parse(localStorage.getItem("company_details")).id;
                // axios.post(`http://localhost:1995/add-it-sevice-provider-company-bank-details?id=${id}`, values)
                axios.post(`https://tapi.alobhatech.com/add-it-sevice-provider-company-bank-details?id=${id}`, values)
                    .then(function (response) {
                        if (response.status == 200) {
                            if (localStorage.getItem("company_bank_details")) {
                                localStorage.removeItem("company_bank_details");
                            }
                            let company_bank_details = response.data.data;
                            localStorage.setItem("company_bank_details", JSON.stringify(company_bank_details))
                            Swal.fire(
                                'Congratulations.',
                                'Data Saved Successfully.',
                                'success'
                            )
                            navigate("/it-service-provider-company-service-offered");

                        } else if (response.status == 201) {
                            Swal.fire(
                                'Warning',
                                'This email already exists.',
                                'warning'
                            )

                        } else if (response.status == 202) {
                            Swal.fire(
                                'Warning',
                                'This Mobile No. already exists.',
                                'warning'
                            )

                        } else {
                            Swal.fire(
                                'Please try again.',
                                'Something went wrong',
                                'error'
                            )
                        }
                    })
                    .catch(function (error) {
                        console.log(`Error:`, error.response)
                        Swal.fire(
                            'Server Error, Please try again later.',
                            'Internal Server Error',
                            'error'
                        )
                    })
            }


        }
    });
    return (
        <>
            <Navbar />

            <section className="service-provider my-5">
                <div className="container">
                    {/* =============Heading================== */}
                    <div className="empanelment-service">
                        <h1>Empanelment For IT Services Provider</h1>
                    </div>
                    {/* ===============Tab Area Start=============== */}
                    <div className="form-tab-area">
                        <ul className="nav nav-pills justify-content-center" id="pills-tab" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" id="pills-home-tab" data-toggle="pill" role="tab" aria-controls="pills-home" aria-selected="true">Company</a>
                            </li>
                            <Link to='/it-service-provider-individual-basic-details'>
                                <li className="nav-item actv-li">
                                    <a className="nav-link" id="pills-profile-tab" data-toggle="pill" role="tab" aria-controls="pills-profile" aria-selected="false">Individual</a>
                                </li>
                            </Link>
                        </ul>
                        {/* <Stepper activeStep={2}
                            styleConfig={{
                                activeBgColor: '#2563b6',
                                activeTextColor: '#fff',
                                inactiveBgColor: '#fff',
                                inactiveTextColor: '#2563b6',
                                completedBgColor: '#fff',
                                completedTextColor: '#2b7cff',
                                // size: '3em'
                            }} className='stepper-custom'
                        >
                            <Step label="Company Details" onClick={() => { navigate('/it-service-provider-company-details') }} />
                            <Step label="Contact Person Details" onClick={() => { navigate("/it-service-provider-company-contact-person-details") }} />
                            <Step label="Bank Details" onClick={() => { navigate("/it-service-provider-company-bank-details") }} />
                            <Step label="Service Details" onClick={() => { navigate("/it-service-provider-company-service-offered") }} />
                        </Stepper> */}
                        <div className="stepper-step mt-5">
                            <ul class="form-stepper form-stepper-horizontal text-center mx-auto pl-0">

                                <li class="form-stepper-completed text-center form-stepper-list" step="1">
                                    <Link class="mx-2" to='/it-service-provider-company-details'>
                                        <span class="form-stepper-circle" >
                                            <span>1</span>
                                        </span>
                                        <div class="label">Company Details</div>
                                    </Link>
                                </li>
                                <li class="form-stepper-completed text-center form-stepper-list" step="2">
                                    <Link class="mx-2" to="/it-service-provider-company-contact-person-details">
                                        <span class="form-stepper-circle text-muted">
                                            <span>2</span>
                                        </span>
                                        <div class="label text-muted">Contact Person Details</div>
                                    </Link>
                                </li>
                                <li class="form-stepper-active text-center form-stepper-list" step="3">
                                    <Link class="mx-2">
                                        <span class="form-stepper-circle text-muted">
                                            <span>3</span>
                                        </span>
                                        <div class="label text-muted">Bank Details</div>
                                    </Link>
                                </li>
                                <li class="form-stepper-unfinished text-center form-stepper-list" step="3">
                                    <Link class="mx-2" to="/it-service-provider-company-service-offered">
                                        <span class="form-stepper-circle text-muted">
                                            <span>4</span>
                                        </span>
                                        <div class="label text-muted">Service Details</div>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="tab-content" id="pills-tabContent">
                            {/* ===============Company Tab Area Start=============== */}
                            <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                <div className="custm-form">
                                    <form id='multistepsform' onSubmit={formik.handleSubmit}>


                                        {/* -----------Bank Details------------ */}
                                        <fieldset style={{ position: "static" }}>
                                            <div className="title mb-4">
                                                <h4>Company Bank Details</h4>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="name_of_organisation">Name of the Organization<span style={{ color: "red" }}>*</span></label>
                                                    <input type="text" readOnly className='form-control' placeholder='Name of the Organization' id='name_of_organisation' name='name_of_organisation'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.name_of_organisation}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.name_of_organisation && formik.errors.name_of_organisation ? (
                                                            <div className='text-danger'>*{formik.errors.name_of_organisation}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Bank Account Number<span style={{ color: "red" }}>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Bank Account Number' id='bank_account_no' name='bank_account_no'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.bank_account_no}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.bank_account_no && formik.errors.bank_account_no ? (
                                                            <div className='text-danger'>*{formik.errors.bank_account_no}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Bank<span style={{ color: "red" }}>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Bank' id='bank_name' name='bank_name'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.bank_name}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.bank_name && formik.errors.bank_name ? (
                                                            <div className='text-danger'>*{formik.errors.bank_name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">Name of the Branch<span style={{ color: "red" }}>*</span></label>
                                                    <input type="text" className='form-control' placeholder='Name of the Branch' id='bank_branch' name='bank_branch'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.bank_branch}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.bank_branch && formik.errors.bank_branch ? (
                                                            <div className='text-danger'>*{formik.errors.bank_branch}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 mb-3">
                                                    <label htmlFor="">IFSC Code<span style={{ color: "red" }}>*</span></label>
                                                    <input type="text" className='form-control' placeholder='IFSC Code' id='bank_ifsc' name='bank_ifsc'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.bank_ifsc}
                                                    />
                                                    <div className="help-block with-errors">
                                                        {formik.touched.bank_ifsc && formik.errors.bank_ifsc ? (
                                                            <div className='text-danger'>*{formik.errors.bank_ifsc}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>

                                            <input type="button" name="previous" className="previous action-button" value="&larr; Previous" onClick={() => { navigate("/it-service-provider-company-contact-person-details") }} />
                                            <input type="submit" name="next" className="next action-button" value="Save and Continue &rarr;" />
                                        </fieldset>

                                        {/* -----------Services Offered Details------------ */}

                                    </form>
                                </div>
                            </div>
                            {/* ===============Company Tab Area End=============== */}

                        </div>
                    </div>

                </div>
            </section>
            <Footer />
            <ToastContainer />
        </>
    )


}

export default ITServiceProviderCompanyBank